export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
      height: (window.innerHeight-320)/2,
      width: 0,
      chartGeom: null,
    };
  },
  watch: {
    data() {
      this.refreshData();
    },
  },
  mounted() {
    const innerWidth = window.innerWidth;
    const innerHeight = window.innerHeight;
    if (innerWidth < 1600) {
      this.height = (innerHeight - 270) / 2;
    }
    this.width = this.$el.clientWidth;
    this.initData();
  },
  methods: {
    initData() {},
    updateData() {},
    refreshData() {
      if (this.chart) {
        this.chart.changeData(this.data);
        if(this.year){
        this.chart
        .source(this.data, {
          days: {
            min: 1,
            max: new Date(this.year,parseInt(this.month),0).getDate(),
            type: 'linear',
            tickCount: new Date(this.year,parseInt(this.month),0).getDate()+1,
          },
          count: {
            alias: '人数',
            formatter: val => {
              if (/\./.test(val)) {
                return '';
              }
              return val;
            },
          },
        })
        .tooltip({
          showTitle: false,
        })
        .line()
        .position('days*count');
      }
        this.chart.render();
        this.updateData();
      }
    },
  },
};
